import {FILES_ORIGIN,readFileCard,type FilesIdentity} from '../shared/files-card.js';
/** User-gesture fallback when cross-origin fetch cannot carry the native Files session. */
export function loadFileCardWindow(id:string,identity:FilesIdentity,signal:AbortSignal):Promise<unknown>{
 const bytes=crypto.getRandomValues(new Uint8Array(32)),nonce=[...bytes].map(n=>n.toString(16).padStart(2,'0')).join('');
 let popup:Window|null=null;
 return new Promise((resolve,reject)=>{
  let done=false,sent=false;
  const finish=(value:unknown,error?:Error)=>{if(done)return;done=true;clearTimeout(deadline);clearInterval(closed);window.removeEventListener('message',receive);signal.removeEventListener('abort',abort);popup?.close();if(error)reject(error);else resolve(value);};
  const abort=()=>finish(null,new DOMException('Aborted','AbortError'));
  const receive=(event:MessageEvent)=>{
   if(done||signal.aborted||event.origin!==FILES_ORIGIN||event.source!==popup)return;
   const d=event.data;if(!d||typeof d!=='object'||Array.isArray(d)||d.nonce!==nonce)return;
   if(d.type==='files-card-ready'&&!sent&&Object.keys(d).sort().join(',')==='nonce,type'){
    sent=true;popup?.postMessage({type:'files-card-request',nonce,id,...identity},FILES_ORIGIN);return;
   }
   if(!sent||d.type!=='files-card-result')return;
   if(d.status===200&&Object.keys(d).sort().join(',')==='nonce,status,type,value'&&readFileCard(d.value,id)){finish(d.value);return;}
   if(Object.keys(d).sort().join(',')==='nonce,status,type'&&[401,403,404,409,503].includes(d.status))finish(null,Object.assign(Error('File card unavailable'),{status:d.status}));
  };
  const deadline=setTimeout(()=>finish(null,Error('File card window timeout')),20000);
  const closed=setInterval(()=>{if(popup?.closed)finish(null,Error('File card window closed'));},500);
  window.addEventListener('message',receive);signal.addEventListener('abort',abort,{once:true});
  if(signal.aborted){abort();return;}
  // Named windows are deliberately avoided: never reuse an unrelated existing tab.
  popup=window.open(`${FILES_ORIGIN}/chat-card-window#${nonce}`,'_blank','popup,width=480,height=240');
  if(!popup)finish(null,Object.assign(Error('File card window blocked'),{code:'files_window_blocked'}));
 });
}
